
import Color from '../data/Color';
import UIButton from './UIButton';
import UIFlex, { copyFlex, IFlex, IUIFlexProps } from './UIFlex';

import './UITabs.scss';

export interface ITab{
    label:string | JSX.Element;
    id:string;
}

export interface IUITabsProps extends IUIFlexProps{
    options:ITab[];
    renderAsLinks?:boolean;
    style?:string;
    selectedId?:string;
    onChange?:($id:string)=>void;
}

UITabs.STYLE_AS_WHITE_DS_TABS = "asWhiteDropShadowTabs";

export function UITabs($props:IUITabsProps){

    let cn:string = "tabs";
    if($props.style) cn+=" "+$props.style;
    if($props.className) cn+=" "+$props.className;

    let flex = copyFlex({},$props.flex);

    
    return (
        <UIFlex className={cn} flex={flex}>
            {$props.options.map(($option,$optionIndex)=>{

                let cnItem:string = "tabItem";
                if($option.id===$props.selectedId){
                    cnItem+=" selected";
                }

                return (
                    <UIButton path={$props.renderAsLinks?$option.id:undefined} color={Color.WHITE} onClick={()=>{
                        if($props.onChange){
                            $props.onChange($option.id);
                        }
                    }} className={cnItem} key={$option.id+$optionIndex} label={$option.label}/>
                );
            })}
        </UIFlex>
    );
}